import * as constants from '../constants/ActionTypes';

const initialState = {
  isModalOpen: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.SHOW_HIDE_COVID_BCP_ALERT:
      return { ...state, isModalOpen: action.payload };

    default:
      return state;
  }
}
